import { IAxiosResponseError } from 'api/types';

export function isAxiosParseError<Request>(response: any): response is IAxiosResponseError<Request> {
  return !!response
    && (response as IAxiosResponseError<Request>).isAxiosError !== undefined
    && !!(response as IAxiosResponseError<Request>).rawError
    && !!(response as IAxiosResponseError<Request>).status
    && (!(response as IAxiosResponseError<Request>).data || !!(response as IAxiosResponseError<Request>).data?.message);
}
